function stylesheet(useActualHostSelector, token) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  return [".target-tabset_align", shadowSelector, " {display: block;width: 94%;padding-left: 32px;}.target-tabset__height", shadowSelector, " {height: 51.8vh;}.target-tab__height", shadowSelector, " {height: 40vh;}"].join('');
}
export default [stylesheet];